import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { US_STATES } from '../../../core/models/us-states';

/**
 * US State Select Component
 *
 * Shared dropdown of US states that works with both reactive (formControlName) and
 * template-driven (ngModel) forms.
 */
@Component({
  selector: 'app-us-state-select',
  standalone: true,
  templateUrl: './app-us-state-select.html',
  host: { class: 'd-block', '[class.is-invalid]': 'invalid' },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UsStateSelect),
      multi: true,
    },
  ],
})
export class UsStateSelect implements ControlValueAccessor {
  @Input() inputId: string | null = null;
  @Input() placeholder: string = 'Select State';
  @Input() display: 'name' | 'code' | 'both' = 'name';
  @Input() invalid?: boolean;

  states = US_STATES;
  value: string = '';
  disabled: boolean = false;

  onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(value: string | null): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelect(event: Event): void {
    this.value = (event.target as HTMLSelectElement).value;
    this.onChange(this.value);
  }
}
